
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as resultd3x9ERkSyNMNUVvkm0SF8q3BoO3TEoWPgNcYAkwyXVYMeta } from "/app/app/pages/dashboard/wallet/top-up/result.vue?macro=true";
import { default as _91gateway_93BXJeWyMgOXdh5JPQs4l1zgmevKDOBYTmFFNUMfaXvkEMeta } from "/app/app/pages/payment/callback/wallet/[gateway].vue?macro=true";
import { default as indexVM48547pAavnA0k1XLASEYveNwkEj_FakliCgJ1_EDwMeta } from "/app/app/pages/payment/callback/zarinpal/index.vue?macro=true";
import { default as indexlnyvqKUeSpPtlziYnYVELdceRRHZYktQhfNjtDIGcXMMeta } from "/app/app/pages/payment/callback/zibal/index.vue?macro=true";
import { default as indexqctbeECbnudan0PQZK1rHbrGesJJF63Wo3KXzy46iy8Meta } from "/app/app/pages/auth/login/index.vue?macro=true";
import { default as index_9RV_wFhe3IzcCWKXrBZ189OAY4C0MxosOnzdQ0RzHoMeta } from "/app/app/pages/dashboard/addresses/index.vue?macro=true";
import { default as indexs5dOmp6ruFS5yA6N31kgTETkI7U__oR5YamOElcNQKwMeta } from "/app/app/pages/dashboard/bookmarks/index.vue?macro=true";
import { default as indexqnw8nDKsh6gEa_qLyVJweWycJ6yhyQnWfLcpaM4wENgMeta } from "/app/app/pages/dashboard/list/index.vue?macro=true";
import { default as indexiPgqguCBRSJX5tDdKhxy5Gzqkl_fNv_RVi3aS0lnhMgMeta } from "/app/app/pages/dashboard/me/index.vue?macro=true";
import { default as indexHUlxOvB2YgImvfKtCpPrptAiJSM8_ZzjwLCq_lQsX30Meta } from "/app/app/pages/dashboard/orders/index.vue?macro=true";
import { default as indexGI3vQZVf_zyN1WVoXkAS1sgrNmkcTfxNC0MSqpAsMGAMeta } from "/app/app/pages/dashboard/wallet/index.vue?macro=true";
import { default as indexHWEmjiDKPskAN33Lg_lMx0dXo3K00Q9NUQaYRXp6llgMeta } from "/app/app/pages/dashboard/index.vue?macro=true";
import { default as indexaa8Z1fdJ4miQH86dXsXKntLqj8_ah6mPs_N29ihY7kIMeta } from "/app/app/pages/links/index.vue?macro=true";
import { default as component_45stub9caUEaAeq_K44cKkobJ27XhwVwi1zX_KT7Kxu9MDHeo } from "/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stub9caUEaAeq_K44cKkobJ27XhwVwi1zX_KT7Kxu9MDHeoMeta } from "/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "dashboard-wallet-top-up-result___fa",
    path: "/dashboard/wallet/top-up/result",
    meta: resultd3x9ERkSyNMNUVvkm0SF8q3BoO3TEoWPgNcYAkwyXVYMeta || {},
    component: () => import("/app/app/pages/dashboard/wallet/top-up/result.vue")
  },
  {
    name: "orders-payment-anonymous-order___fa",
    path: "/orders/payment/anonymous/:order()",
    component: () => import("/app/app/pages/orders/payment/anonymous/[order].vue")
  },
  {
    name: "payment-callback-wallet-gateway___fa",
    path: "/payment/callback/wallet/:gateway()",
    meta: _91gateway_93BXJeWyMgOXdh5JPQs4l1zgmevKDOBYTmFFNUMfaXvkEMeta || {},
    component: () => import("/app/app/pages/payment/callback/wallet/[gateway].vue")
  },
  {
    name: "payment-callback-zarinpal___fa",
    path: "/payment/callback/zarinpal",
    meta: indexVM48547pAavnA0k1XLASEYveNwkEj_FakliCgJ1_EDwMeta || {},
    component: () => import("/app/app/pages/payment/callback/zarinpal/index.vue")
  },
  {
    name: "payment-callback-zibal___fa",
    path: "/payment/callback/zibal",
    meta: indexlnyvqKUeSpPtlziYnYVELdceRRHZYktQhfNjtDIGcXMMeta || {},
    component: () => import("/app/app/pages/payment/callback/zibal/index.vue")
  },
  {
    name: "dashboard-orders-id-factor___fa",
    path: "/dashboard/orders/:id()/factor",
    component: () => import("/app/app/pages/dashboard/orders/[id]/factor/index.vue")
  },
  {
    name: "dashboard-orders-id___fa",
    path: "/dashboard/orders/:id()",
    component: () => import("/app/app/pages/dashboard/orders/[id]/index.vue")
  },
  {
    name: "auth-login___fa",
    path: "/auth/login",
    meta: indexqctbeECbnudan0PQZK1rHbrGesJJF63Wo3KXzy46iy8Meta || {},
    component: () => import("/app/app/pages/auth/login/index.vue")
  },
  {
    name: "dashboard-addresses___fa",
    path: "/dashboard/addresses",
    meta: index_9RV_wFhe3IzcCWKXrBZ189OAY4C0MxosOnzdQ0RzHoMeta || {},
    component: () => import("/app/app/pages/dashboard/addresses/index.vue")
  },
  {
    name: "dashboard-bookmarks___fa",
    path: "/dashboard/bookmarks",
    meta: indexs5dOmp6ruFS5yA6N31kgTETkI7U__oR5YamOElcNQKwMeta || {},
    component: () => import("/app/app/pages/dashboard/bookmarks/index.vue")
  },
  {
    name: "dashboard-list___fa",
    path: "/dashboard/list",
    meta: indexqnw8nDKsh6gEa_qLyVJweWycJ6yhyQnWfLcpaM4wENgMeta || {},
    component: () => import("/app/app/pages/dashboard/list/index.vue")
  },
  {
    name: "dashboard-me___fa",
    path: "/dashboard/me",
    meta: indexiPgqguCBRSJX5tDdKhxy5Gzqkl_fNv_RVi3aS0lnhMgMeta || {},
    component: () => import("/app/app/pages/dashboard/me/index.vue")
  },
  {
    name: "dashboard-orders___fa",
    path: "/dashboard/orders",
    meta: indexHUlxOvB2YgImvfKtCpPrptAiJSM8_ZzjwLCq_lQsX30Meta || {},
    component: () => import("/app/app/pages/dashboard/orders/index.vue")
  },
  {
    name: "dashboard-wallet___fa",
    path: "/dashboard/wallet",
    meta: indexGI3vQZVf_zyN1WVoXkAS1sgrNmkcTfxNC0MSqpAsMGAMeta || {},
    component: () => import("/app/app/pages/dashboard/wallet/index.vue")
  },
  {
    name: "product-best-sellers___fa",
    path: "/product/best-sellers",
    component: () => import("/app/app/pages/product/best-sellers/index.vue")
  },
  {
    name: "product-slug___fa",
    path: "/product/:slug()",
    component: () => import("/app/app/pages/product/[slug].vue")
  },
  {
    name: "category-slug___fa",
    path: "/category/:slug(.*)*",
    component: () => import("/app/app/pages/category/[...slug]/index.vue")
  },
  {
    name: "about___fa",
    path: "/about",
    component: () => import("/app/app/pages/about/index.vue")
  },
  {
    name: "cart___fa",
    path: "/cart",
    component: () => import("/app/app/pages/cart/index.vue")
  },
  {
    name: "category___fa",
    path: "/category",
    component: () => import("/app/app/pages/category/index.vue")
  },
  {
    name: "contact___fa",
    path: "/contact",
    component: () => import("/app/app/pages/contact/index.vue")
  },
  {
    name: "dashboard___fa",
    path: "/dashboard",
    meta: indexHWEmjiDKPskAN33Lg_lMx0dXo3K00Q9NUQaYRXp6llgMeta || {},
    component: () => import("/app/app/pages/dashboard/index.vue")
  },
  {
    name: "links___fa",
    path: "/links",
    meta: indexaa8Z1fdJ4miQH86dXsXKntLqj8_ah6mPs_N29ihY7kIMeta || {},
    component: () => import("/app/app/pages/links/index.vue")
  },
  {
    name: "namad___fa",
    path: "/namad",
    component: () => import("/app/app/pages/namad/index.vue")
  },
  {
    name: "payment___fa",
    path: "/payment",
    component: () => import("/app/app/pages/payment/index.vue")
  },
  {
    name: "privacy-policy___fa",
    path: "/privacy-policy",
    component: () => import("/app/app/pages/privacy-policy/index.vue")
  },
  {
    name: "search___fa",
    path: "/search",
    component: () => import("/app/app/pages/search/index.vue")
  },
  {
    name: "terms-and-conditions___fa",
    path: "/terms-and-conditions",
    component: () => import("/app/app/pages/terms-and-conditions/index.vue")
  },
  {
    name: "test___fa",
    path: "/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "user___fa",
    path: "/user",
    component: () => import("/app/app/pages/user/index.vue")
  },
  {
    name: "index___fa",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: component_45stub9caUEaAeq_K44cKkobJ27XhwVwi1zX_KT7Kxu9MDHeoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub9caUEaAeq_K44cKkobJ27XhwVwi1zX_KT7Kxu9MDHeo
  }
]